var map = {
	"./Aspirion/image1.png": 2238,
	"./Doc Talents/image1.png": 485,
	"./MindScape/image1.png": 4802,
	"./Portfolio/image1.png": 9433,
	"./Smart Time Planner/image1.png": 6307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7152;